module.exports = __webpack_public_path__ + "static/media/icon-case-story.822c486e.svg";